<template>
  <div id="app">
    <div class="w-100 vh-100 " id="app-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'app',
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.w-20 {
  width: 20%;
}
#app {
  font-family: 'Poppins', 'Roboto', 'Avenir', Helvetica, Arial, sans-serif;
  position: relative;

  &-content {
    display: flex;
    align-items: center;
    // height: calc(100vh - 59px);
  }

  &-wrapper-web {
    width: 100%;
    height: 100%;
  }
}
.app-wrapper-content {
  height: calc(100vh - 59px);
}
:root {
  --color-upp: #96e0ff;
  --color-low: #2eafff;
  --color-main: #006dd7;

  --color-secundary: #43a5ab;
  --color-secundary-disabled-opacity: #43a5ab33;
  --color-plain: #dfefff;
  --color-gray: #dedede;
  --pale-gray: #dee2e6;

  --color-neutral: #2c2e3b;

  --blue-low: #2eafff;

  --green-plain: #e3fffc;
  --green-low: #48d9ca;

  --rose-plain: #ffede1;
  --rose-low: #f29f8d;
  --pale-pink: #ffd2d2;

  --yellow-plain: #fcfcee;
  --yellow-low: #f5c952;

  --bg-gradient: linear-gradient(var(--color-upp) 0%, var(--color-low) 100%);

  --navy: #016193;
  --olive: #1d8691;
  --sunrise: #f98e35;

  --green-fluo: #4aef65;
  --green-btn: #b2db90;

  --orange-pri: #ee6123;
  --yellow-pri: #f7b32b;
  --green-pri: #485696;
  --blue-pri: #4ba3c3;

  --high: #ff5569;
  --normal: #ff7648;
  --moderate: #f9c132;

  --orange: #f6a724;
  --yellow-light: #feec58;
  --color-navbar: #58e1ea;
  --color-navbar-disabled-opacity: #58e1ea33;

  --pending: #bef3d3;
  --denied: #ff5569;
  --accepted: #5de192;
  --color-accepted-disabled-opacity: #5de19233;

  --atm-shadow: 2px 2px 6px rgb(0 0 0 / 25%);
  --atm-border-radius: 0.8rem;
}

.mobile {
  background: white;
  padding: 3rem;
  border-radius: 24px 24px 0 0 !important;
  margin-top: -24px !important;
}

.color-main {
  color: var(--color-main);
}

.color-main-low {
  color: var(--color-low);
}

.color-secundary {
  color: var(--color-secundary);
}

.color-gray {
  color: var(--color-gray);
}

.bg-navbar {
  background-color: var(--color-navbar) !important;
}
color-lowcolor-low .text-link {
  color: var(--color-navbar) !important;
}

.bg-secundary {
  background-color: var(--color-secundary);
}

.bg-gradient {
  background: var(--color-secundary);
}
.bg-main {
  background-color: var(--color-main) !important;
  border: 0 !important;
}
.bg-plain {
  background-color: var(--color-plain) !important;
}
.bg-main-low {
  background-color: var(--color-low) !important;
}

.bg-gray {
  background-color: var(--color-gray) !important;
}
.bg-white {
  background-color: white !important;
}
.bg-green {
  background-color: var(--green-fluo) !important;
}

.bg-green-btn {
  background-color: var(--green-btn) !important;
  border-color: var(--green-btn) !important;
}
.bg-yellow {
  background-color: var(--yellow-light) !important;
}
.bg-blue-dark {
  background-color: #383c6b !important;
}

.text-main {
  color: var(--color-main) !important;
}
a {
  color: var(--color-main) !important;
}
a:active {
  background-color: transparent !important;
}
a.badge {
  color: initial !important;
}
.border-main {
  border-color: var(--color-main) !important;
}
.outline-main {
  color: var(--color-main) !important;
  border-color: var(--color-main) !important;
  background-color: transparent !important;
}
.outline-main:hover {
  background-color: var(--color-main) !important;
  color: #fff !important;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: var(--color-main) !important;
  background-color: var(--color-main) !important;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: var(--color-main) !important;
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  opacity: 0.6 !important;
}
.input-blue .custom-control-input:checked ~ .custom-control-label::before {
  border-color: var(--color-main) !important;
  background-color: var(--color-main) !important;
}
input {
  &.atm-time {
    position: relative;
    height: 50px;
    border: none;
    border-radius: 0.5rem;
    // padding: 0.7rem 0;
    &:focus {
      background-color: #f3f3f3;
      outline: none;
    }
  }
}
input[type='time']::-webkit-calendar-picker-indicator {
  &.atm-time {
    position: absolute;
    width: 100%;
    opacity: 0;
  }
}

.blue-palette {
  color: var(--blue-low);
}
.green-palette {
  color: var(--green-low);
}
.rose-palette {
  color: var(--rose-low);
}
.yellow-palette {
  color: var(--yellow-low);
}

.bg-blue-palette {
  background-color: var(--blue-low);
}
.bg-green-palette {
  background-color: var(--green-low);
}
.bg-rose-palette {
  background-color: var(--rose-low);
}
.bg-yellow-palette {
  background-color: var(--yellow-low);
}

.dark-blue-palette {
  color: var(--dark-blue-low);
}
.dark-green-palette {
  color: var(--dark-green-low);
}
.dark-rose-palette {
  color: var(--dark-rose-low);
}
.dark-yellow-palette {
  color: var(--dark-yellow-low);
}

.bg-navy {
  background-color: var(--navy) !important;
}
.bg-olive {
  background-color: var(--olive) !important;
}
.bg-orange {
  background-color: var(--sunrise) !important;
}

.bg-muted {
  background-color: #f2f2f2 !important;
}

.pri-critical {
  color: var(--orange-pri);
}
.pri-high {
  color: var(--high);
}
.pri-normal {
  color: var(--normal);
}
.pri-moderate {
  color: var(--moderate);
}
.bg-pri-high {
  background-color: var(--high) !important;
}
.bg-pri-normal {
  background-color: var(--normal) !important;
}
.bg-pri-moderate {
  background-color: var(--moderate) !important;
}

.text-blue {
  color: var(--blue-low);
}
.text-blue-dark {
  color: #383c6b;
}
.text-green-dark {
  color: #006837 !important;
}
.text-green-fluo {
  color: var(--green-fluo) !important;
}
.text-orange {
  color: var(--orange) !important;
}
.text-xmuted {
  color: #cccccc;
}

.border-2 {
  background-color: #f2f2f2;
  border: 1px solid #cccccc;
  color: #999999;
  font-size: 1.2em !important;
  padding: 0.1em !important;
}
.border-muted {
  border: 1px solid #e6e6e6;
}

.border {
  &-main {
    border: solid 1px var(--color-main) !important;
  }
  &-main-bottom {
    border-bottom: solid 1px;
    border-color: var(--color-main) !important;
  }
}

.full-icon {
  font-size: 8em !important;
  color: #e6e6e6;
}
.big-icon {
  font-size: 2.5em !important;
}
.medium-icon {
  font-size: 1.3em !important;
}
.small-icon {
  font-size: 0.7em !important;
}
.small-coin {
  width: 20px;
}

.material-icons-round {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;

  -ms-user-select: none;
  user-select: none;
}

.square {
  float: left;
}
.square:before {
  content: '';
  display: block;
  float: left;
}
.content {
  margin-top: 20% !important;
  padding: 2%;
}
.content-badge {
  margin-top: 8% !important;
}

.dark-badge .img-fluid {
  filter: invert(100%) !important;
}

.nav-pills .nav-link {
  border-radius: 0 !important;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d !important;
  background-color: transparent !important;
  border-color: transparent !important;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff !important;
}

.float-button-right {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 3;
}
.float-bottom {
  position: fixed;
  bottom: 20px;
}

.lateral-menu {
  padding-top: 20px;
}

.navbar-nav {
  z-index: 3 !important;
  border-radius: 0 26px 26px 0;

  @media (max-width: 991px) {
    border-radius: 26px;
  }
}

.nav-link {
  padding: 0.5rem 0 !important;
  text-align: center !important;
}
.nav-tabs .nav-item {
  width: 25% !important;
}

.card-header {
  padding: 0 !important;
}
.card-header-tabs {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  border-bottom: 0 !important;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #383c6b !important;
  background-color: #fff !important;
  border-color: #dee2e6 #dee2e6 #fff !important;
  height: 100% !important;
}

.task-list .list-group-item:nth-child(even) {
  background-color: #f6f6f6 !important;
}

.cursor {
  cursor: pointer !important;
}
.cursor:hover {
  background: rgba(0, 0, 0, 0.04);
}

.main {
  min-height: calc(100vh - 45px);
}

.bg-coin {
  background-image: url('assets/coin2.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top center;
  color: #000;
  min-height: 67px;
}
.bg-coin-medium {
  background-image: url('assets/coin.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top center;
  color: #f6a724;
  min-height: 40px;
}
.bg-coin-medium .small {
  font-size: 0.6em;
}
.bg-coin .ph1 {
  font-size: 1.2em;
}
.bg-coin .ph2 {
  font-size: 1.2em;
}

.flex-wrap-baseline {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}

.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 3rem;
}

.font-weight-600 {
  font-weight: 600;
}

.bg-clear {
  background-color: transparent;
}

.text-sm {
  font-size: 0.8rem;
}

section > .badge-secondary {
  background-color: var(--color-main);
  color: white;
  font-weight: 600;
  user-select: none;
  box-shadow: 1px 1px 8px #ccc;
}

/***************************
*  ATOM CUSTOM COMPONENTS  *
***************************/
.project-list .label {
  position: relative;
  transition: opacity 0.2s linear;
}

.wrapper-projects {
  background: white;
  margin-top: -1rem;
  border-radius: 1.2rem;
}

.project-card {
  border-radius: 1rem !important;
  background: #a9e27a !important;

  &.unabled {
    opacity: 0.7;
    .label,
    .progress-wrap {
      color: white;
    }
  }

  &.done {
    .label {
      text-decoration: line-through;
    }
  }
}

.atm-button {
  height: 56px;
  color: white;
  font-weight: 600;
  text-transform: capitalize;
  border: none;
  border-radius: 0.5rem;
  box-shadow: var(--atm-shadow);
  transition: 200ms;
  &:hover {
    filter: brightness(0.9);
    transform: scale(1.02);
  }
}

.atm-input {
  background-color: #f3f3f3;
  height: 48px;
  min-width: 200px;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  box-shadow: var(--atm-shadow);
}

.atm-input-title {
  color: var(--color-main);
  font-size: 1.3rem;
  font-weight: 600;
  padding: 0;
  border: none;
  border-bottom: 2px solid var(--color-main);
  border-radius: 0;

  &::placeholder {
    color: var(--color-main);
  }
}

.atm-input-time {
  position: relative;
  height: 48px;
  border: none;
  border-radius: 0.5rem;
  padding: 0.5rem 0.7rem;
  &:hover {
    background-color: #f3f3f3;
  }
  &:focus {
    background-color: #f3f3f3;
    outline: none;
  }
}

input[type='checkbox'] {
  display: none;
}

input[type='checkbox'] + label {
  position: relative;
  display: inline-block;
  background-color: #f3f3f3;
  min-width: 32px;
  max-width: 32px;
  min-height: 32px;
  max-height: 32px;
  padding: 0px;
  margin: auto;
  margin-right: 16px;
  border-radius: 8px;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);
}

input[type='checkbox']:checked + label {
  background-color: var(--color-main);
  color: white;
}

input[type='checkbox']:checked + label:after {
  margin: auto;
  text-align: center;
  position: absolute;
  top: 11.25%;
  left: 11.25%;
  color: #fff;
  content: 'done';
  font-size: 24px;
}

input[type='range'] {
  -webkit-appearance: none;
  width: 100%;
  margin: 1.2rem 0;
  background: transparent;
}

input[type='range']::-webkit-slider-runnable-track {
  width: 100%;
  height: 8px;
  background: #f1f1f1;
  border-radius: 1.3px;
  cursor: pointer;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 30px;
  width: 30px;
  margin-top: -10px;
  border: none;
  border-radius: 100%;
  background: var(--color-main);
  cursor: pointer;
}

/* All the same stuff for Firefox */
input[type='range']::-moz-range-thumb {
  height: 30px;
  width: 30px;
  border: none;
  border-radius: 100%;
  background: var(--color-main);
  cursor: pointer;
}

/* All the same stuff for IE */
input[type='range']::-ms-thumb {
  height: 30px;
  width: 30px;
  border: none;
  border-radius: 100%;
  background: var(--color-main);
  cursor: pointer;
}

input[type='range']:focus {
  outline: none;
}
input[type='range']::-ms-track {
  width: 100%;
  cursor: pointer;

  background: transparent;
  border-color: transparent;
  color: transparent;
}

/***********************
*  ATOM CUSTOM STYLES  *
***********************/

.atm-rounded {
  border-radius: 0.8rem !important;
}
.atm-rounded-bottom {
  border-radius: 0 0 0.8rem 0.8rem !important;
}
.atm-rounded-top {
  border-radius: 0.8rem 0.8rem 0 0 !important;
}

.atm-shadow {
  box-shadow: var(--atm-shadow);
}

.atm-shadow-main {
  box-shadow: 0 0 6px var(--color-main);
}

.atm-desktop-max-width {
  margin-left: auto;
  margin-right: auto;
  max-width: 1000px !important;
}

input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-calendar-picker-indicator,
input[type='time']::-webkit-calendar-picker-indicator {
  position: absolute;
  width: 100%;
  opacity: 0;
}

@media (min-width: 992px) {
  .mt-lg-100 {
    margin-top: 48px;
  }
  .main {
    min-height: auto;
  }
  #nav-collapse {
    display: none !important;
  }
  .sticky-top {
    display: flow-root !important;
  }
  .btn-block {
    width: 30% !important;
    margin: 0 auto;
  }
  .bg-congrats .bg-white {
    height: 650px !important;
  }

  #app-wrapper-web {
    position: relative;
    // max-width: 992px;
    // height: 730px;
    // border-radius: 20px;
    overflow: hidden;
    -webkit-box-shadow: 4px 4px 10px 0px rgba(173, 173, 173, 1);
    -moz-box-shadow: 4px 4px 10px 0px rgba(173, 173, 173, 1);
    box-shadow: 4px 4px 10px 0px rgba(173, 173, 173, 1);
  }
  .smaller {
    font-size: 80% !important;
  }
  // .vh-100 {
  //   height: 620px !important;
  // }
  .bar-side .w-25 {
    width: 35% !important;
  }
  .background {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    box-shadow: 5px 1px 12px #0000001f;
    z-index: 10;
  }
  .bg-medium {
    height: 200px;
    //color: var(--color-upp);
  }
  .app-wrapper-content {
    overflow-y: auto;
    overflow-x: hidden;
  }
  .app-wrapper-content::-webkit-scrollbar {
    width: 0.4em;
  }
  .app-wrapper-content::-webkit-scrollbar-thumb {
    background-color: rgba($color: #000, $alpha: 0.4);
  }
  .float-bottom {
    position: absolute !important;
    bottom: -6px !important;
    right: 0 !important;
    left: auto !important;
    width: 74% !important;
    border: 0 1px 0 1px !important;
  }
  .float-button-right {
    position: absolute !important;
    right: 20px !important;
    bottom: 10px !important;
    z-index: 3 !important;
  }
}
@media (max-width: 991px) {
  .p-100 {
    padding: 7% !important;
  }
  .p-20 {
    padding-top: 20px !important;
  }
}

@media screen and (max-width: 768px) {
  .none-padding-mobile {
    padding-left: 0rem;
    padding-right: 0rem;
  }
}

@media (min-width: 1200px) {
  .container,
  .container-lg {
    max-width: 1800px !important;
  }
}
@media (min-width: 768px) {
  .container,
  .container-md {
    max-width: 1800px !important;
  }
  .btn-block {
    width: 50% !important;
    margin: 0 auto;
  }
}
@media (min-width: 576px) {
  .container,
  .container-sm {
    max-width: 1800px !important;
  }
  .intro .card-group {
    display: initial !important;
  }
  .intro .card-group > .card {
    margin: 1% 16% !important;
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
  }
}
@media (max-width: 380px) {
  .square {
    padding: 0 !important;
  }
  .bg-coin {
    background-size: contain !important;
  }
  .module-title {
    width: 50%;
    margin: 0 auto;
  }
}

.emptyNavBar {
  height: 68px;
}

/* LOADER PAGE */
.loader {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}
#loader-1:before,
#loader-1:after {
  content: '';
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: 10px solid transparent;
  border-top-color: var(--color-main);
}
#loader-1:before {
  z-index: 100;
  animation: spin 1s linear infinite;
}
#loader-1:after {
  border: 10px solid var(--color-gray);
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
